import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import { equal } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import moment from "cc-frontend/utils/extended-moment"
import _ from "lodash"
import findDocument from "../../helpers/find-document"

export default class CourseDateController extends Controller {
  @service("ember-store")
  store

  queryParams = [
    "startDate",
    "endDate",
    "headerText",
    "showComments",
    "showStandardDescriptions",
    "isFilteringCards",
    "visibleCards",
    "pageBreaks",
  ]

  showComments = false
  showStandardDescriptions = true
  isFilteringCards = false
  visibleCards = []
  pageBreaks = "none"

  @findDocument("model.courseId", "course")
  course

  @belongsTo("course", "planbook")
  planbook

  @belongsTo("planbook.content", "rotationCalendar")
  rotationCalendar

  @equal("pageBreaks", "after-class")
  pageBreakAfterClass

  @computed("pageBreaks")
  get normalPageBreaks() {
    return get(this, "pageBreaks") === "none" || get(this, "pageBreaks") === ""
  }

  @computed("startDate", "endDate", "rotationCalendar.content.attributes.schoolDays")
  get dateStrings() {
    let validSchoolDays = get(this, "rotationCalendar.content.attributes.schoolDays")

    let startDate = get(this, "startDate")
    let endDate = get(this, "endDate")

    let range = moment.range(startDate, endDate)
    let acc = []
    Array.from(range.by("days")).map((moment) => {
      if (_.includes(validSchoolDays, moment.weekday())) acc.push(moment)
    })
    let newDates = _.uniq(_.map(acc, (m) => m.format("YYYY-MM-DD")))

    return newDates
  }

  @computed("dateStrings.[]")
  get perspective() {
    return this.dateStrings.length > 1 ? "week" : "day"
  }
}
